const constants = {
    screenWidthBreakpoints: {
        lessThanSm: 575.98,
        sm: 576,
        md: 768,
        lessThanMd: 767.98,
        lg: 992,
        lessThanLg: 991.98,
        xl: 1200,
        lessThanXl: 1199.98,
    }
};

export default constants;